'use client'

import { createContext, useContext, useMemo } from 'react'

export type RailItemContextType = {
  slug?: string
  position?: number
}

export const RailItemContext = createContext<RailItemContextType>({})

export const RailItemContextProvider = ({
  children,
  slug,
  position,
}: {
  children: React.ReactNode
} & RailItemContextType) => {
  const value = useMemo(() => ({ slug, position }), [slug, position])

  return <RailItemContext.Provider value={value}>{children}</RailItemContext.Provider>
}

export const useRailItemContext = () => {
  const context = useContext(RailItemContext)
  if (!context) {
    throw new Error('useRailItemContext must be used within a RailItemContextProvider')
  }
  return context
}
